<template>
	<div class="site-wrapper">
		<div class="site-content" :class="{ 'loading-blur': !bet && !betTypes }">

			<div class="page">
				<div class="page__header">
					<div class="page__container">
						<h1 class="page__title">
							{{ t('page.betguide.title') }}
						</h1>
					</div>
				</div><!-- /.page__header -->

				<div class="page__content" v-if="betTypes">

					<div class="container-fluid bet-guide">
						<div class="row bet-guide__head">
							<div class="container">
								<div class="row">
									<div class="col-12 col-lg-9">
										<ul class="bet-guide__list">
											<li class="bet-guide__list__item"
                                     v-for="item in betTypes"
                                     :key="'betg-a-'+snakeCase(bet.name)"
												:class="{ 'is-active bg-primary': betId && snakeCase(item.betId) === snakeCase(bet.name)}">
												<router-link
														:to="{name: 'BetGuideId', params: { betId: snakeCase(item.name) }}">
                                       <game
                                           :bet="{code: item.name}"
                                       />
												</router-link>
											</li>
										</ul>
									</div>
									<div class="col-12 col-lg-3">
										<div class="bet-guide__head__right-logo" v-if="rule.param.hasspot || rule.param.hasjackpot">
											<div class="bet-guide__head__right-logo__item" v-if="rule.param.hasspot">
												<img src="../img/types/spot.png" width="55px">
											</div>

											<div class="bet-guide__head__right-logo__item" v-if="rule.param.hasjackpot">
												<img src="../img/types/jackpot.png">
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="row bet-guide__params">
							<div class="container">
								<div class="row">
									<div class="col-12">
										<ul class="bet-guide__params-list d-flex flex-row justify-content-between">
											<li class="bet-guide__params-list__item" v-if="bet.minhorse !== null">
												<div class="text-bold">
													{{t("page.bet-guide.params.minHorse")}}
												</div>
												<div class="bet-guide__params-list__item__param">
													{{ bet.minhorse }}
												</div>
											</li>
											<li class="bet-guide__params-list__item" v-if="bet.minstake !== null">
												<div class="text-bold">
													{{t("page.bet-guide.params.minBet")}}
												</div>
												<div class="bet-guide__params-list__item__param">
													{{ formatToMoney(bet.minstake) }}
												</div>
											</li>
											<li class="bet-guide__params-list__item" v-if="bet.frequency !== null">
												<div class="text-bold">
													{{t("page.bet-guide.params.frequency")}}
												</div>
												<div class="bet-guide__params-list__item__param">
													{{ bet.frequency }}
												</div>
											</li>
											<!--<li class="bet-guide__params-list__item" v-if="bet.chance !== null">
												<div class="text-bold">
													{{t("page.bet-guide.params.chance")}}
												</div>
												<div class="bet-guide__params-list__item__param">
													{{ bet.chance }}
												</div>
											</li>-->
										</ul>
									</div>
								</div>
							</div>
						</div>
						<div class="container" @click="contentClick($event)">
							<div class="row">
								<div class="col-12">
									<div class="bet-guide__content">
										<h1 v-html="bet.title">

										</h1>
									</div>

								</div>
								<div class="col-12" v-html="bet.description">
									<div class="bet-guide__content">

									</div>
								</div>
							</div>
						</div>



					</div>
				</div><!-- /.page__content -->
			</div><!-- /.page -->

		</div>
	</div>
</template>
<script>
	import store from '@/store';


	export default {
		name: 'BetGuide',
		beforeRouteEnter(to, from, next) {

			store.commit('addLoad', 'getGuide');
			store.dispatch('getBetGuides').then(() => {

				next();

			}).catch(function (error) {
				console.warn('No bet get from db');
				console.warn(error);

			}).then(() => {
				store.commit('endLoad', 'getGuide');
			});

		},
		data() {
			return {

			}
		},
		computed: {
			rules(){
				//return all bet types rules
				return this.$store.state.race.rules;
			},
			rule(){
				return this.rules.find( rule => {
					return this.bet && this.snakeCase(rule.name) === this.snakeCase(this.bet.name);
				});
			},
			betTypes(){
				return this.sortGuideBettype(this.$store.state.once.betGuide.slice());
			},
			betId() {
				return this.$route.params['betId'];
			},
			bet(){

				let id =  this.betId;

				//Check if we have defined id otherwise use firs found bettype
				if( typeof id === 'undefined' && this.betTypes.length > 0){
					id = this.snakeCase(this.betTypes[0].name);
				}

				let bet = this.betTypes.find((el)=>{
					return this.snakeCase(el.name) === this.snakeCase(id);
				});


				if(bet){
					return bet;
				}else{
					//If we not found bet type goto redirect to first one
					this.$router.replace({ name: 'BetGuide'})
				}
			}
		},
		mounted() {
			this.$store.dispatch('getBetGuides');
		},
		methods: {

			contentClick(event){
				if(event.target.dataset.toggle && event.target.dataset.toggle === 'collapse'){
					let clpps = this.$el.querySelectorAll(event.target.dataset.target);

					for(let el of clpps){
						if(el.classList.contains('show')){
							el.classList.remove('show')
						}else{
							el.classList.add('show')
						}
					}
				}
			},
			sortGuideBettype(array){

				return array.slice().sort((a, b)=>{

					return this.$store.getters.getTypePriorityByName(a.name) - this.$store.getters.getTypePriorityByName(b.name);
				})
			},
		}
	}

</script>
<style lang="scss">

	[data-toggle="collapse"]{
		cursor: pointer;
	}
</style>
